import { FC } from 'react'
import cn from 'classnames'
import { SellerGridProps } from '.'
import s from './seller-grid.module.css'

const SellerProfile: FC<SellerGridProps> = ({ className = '', children }) => {
  return <div className={cn(s.root, className)}>{children}</div>
}

export default SellerProfile
